var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 78,
    viewBox: "0 0 91 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.100006 0.199986C0.500008 -1.432e-05 0.800011 0.699986 1.00001 0.899985C7.7 14.9 16.7 27.5 27.9 38.2C38.7 48.5 51.2 57 64.6 63.6C71.9 67.2 79.4 70.3 87.1 72.9C84.4 69.5 81.4 66.4 78.2 63.5C77.8 63.2 77.5 62.7 77.5 62.2C77.5 62 77.4 61.3 77.8 61.6C80.1 63.6 82.3 65.7 84.3 67.9C85.4 69.1 86.4 70.3 87.4 71.5C88.2 72.5 89.2 73.5 89.7 74.6C90 75.3 90.3 76.3 89.7 76.9C89 77.7 87.2 77.5 86.2 77.6C82.8 77.9 79.5 77.9 76.1 77.8C75.5 77.8 74.7 75.5 75.2 75.4C77.6 75.2 80 75 82.5 75C83.3 75 84.1 75 85 75C57.1 65.3 31.6 48.8 13.8 25C8.40001 17.8 3.80001 9.99999 0.300011 1.69999C0.200012 1.39999 -0.199997 0.299986 0.100006 0.199986Z",
    fill: "#FF2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrow_red.9fbd404067219b6bcc8fc691ed734c12.svg";
export { ForwardRef as ReactComponent };